import { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { GOLD, BLUE, TEMAS } from "../constants/temas";

const API = process.env.REACT_APP_API_URL || "https://adorateam-api-532602191494.us-central1.run.app";
const EMOJIS_REACAO = ["👍", "❤️", "🙏", "🔥", "🎉"];
const FUNCAO_ICONE = {
    Soprano: "🎤", Contralto: "🎤", Tenor: "🎤", Barítono: "🎤",
    Violão: "🪕", Guitarra: "🎸", Baixo: "🎵", Teclado: "🎹",
    Bateria: "🥁", Sopro: "🎺", BANDA: "🎸", Outro: "🎵",
};

function getToken() { return localStorage.getItem("adorateam_token"); }

function tempoRelativo(dt) {
    if (!dt) return "";
    const diff = (Date.now() - new Date(dt).getTime()) / 1000;
    if (diff < 60) return "agora";
    if (diff < 3600) return `${Math.floor(diff / 60)}min`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
    if (diff < 604800) return `${Math.floor(diff / 86400)}d`;
    return new Date(dt).toLocaleDateString("pt-BR", { day: "2-digit", month: "short" });
}

function Avatar({ foto, nome, size = 44 }) {
    const inicial = (nome || "?")[0].toUpperCase();
    return (
        <div style={{
            width: size, height: size, borderRadius: "50%", flexShrink: 0,
            overflow: "hidden", border: `2px solid ${GOLD}44`,
            background: `linear-gradient(135deg, ${GOLD}33, #1a2540)`,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: size * 0.38, fontWeight: 800, color: GOLD,
        }}>
            {foto && !foto.startsWith("data:image")
                ? <img src={foto} alt={nome}
                       style={{ width: "100%", height: "100%", objectFit: "cover" }}
                       onError={e => { e.target.style.display = "none"; e.target.parentNode.innerHTML = inicial; }} />
                : inicial}
        </div>
    );
}

function CardMembro({ membro, souEu, adminMode, onEditar, tema: T }) {
    const funcao = membro.funcao || membro.instrumento || "BANDA";
    const icone = FUNCAO_ICONE[funcao] || "🎵";
    const roleLabel = membro.role === "lider" ? "👑 Líder" : null;
    return (
        <div style={{
            display: "flex", alignItems: "center", gap: 12,
            background: T.bgCard, borderRadius: 16,
            padding: "12px 14px", marginBottom: 10,
            border: `1px solid ${souEu ? GOLD + "44" : T.borda}`,
            boxShadow: souEu ? `0 2px 12px ${GOLD}18` : "none",
        }}>
            <Avatar foto={membro.foto || membro.foto_url} nome={membro.nome} size={46} />
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <div style={{ fontSize: 14, fontWeight: 800, color: T.texto, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{membro.nome}</div>
                    {roleLabel && <span style={{ fontSize: 10, color: GOLD, background: `${GOLD}18`, borderRadius: 6, padding: "1px 6px", flexShrink: 0 }}>{roleLabel}</span>}
                    {souEu && <span style={{ fontSize: 10, color: T.textoSecundario, flexShrink: 0 }}>• você</span>}
                </div>
                <div style={{ fontSize: 12, color: GOLD, fontWeight: 600, marginTop: 1 }}>{icone} {funcao}</div>
                {membro.frase && (
                    <div style={{ fontSize: 11, color: T.textoSecundario, fontStyle: "italic", marginTop: 3, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        "{membro.frase}"
                    </div>
                )}
            </div>
            {(souEu || adminMode) && (
                <button onClick={() => onEditar(membro)} style={{ background: "none", border: `1px solid ${T.borda}`, borderRadius: 8, padding: "4px 10px", color: T.textoSecundario, fontSize: 11, cursor: "pointer", flexShrink: 0 }}>✏️</button>
            )}
        </div>
    );
}

function ModalEditarFrase({ membro, onSalvar, onFechar, tema: T }) {
    const [frase, setFrase] = useState(membro?.frase || "");
    const [salvando, setSalvando] = useState(false);
    const salvar = async () => {
        setSalvando(true);
        try {
            await fetch(`${API}/api/grupos/membros/${membro.id}/frase`, {
                method: "PATCH",
                headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
                body: JSON.stringify({ frase }),
            });
            onSalvar(membro.id, frase);
        } catch { onSalvar(membro.id, frase); }
        finally { setSalvando(false); }
    };
    return createPortal(
        <div onClick={onFechar} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 99999, display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
            <div onClick={e => e.stopPropagation()} style={{ width: "100%", maxWidth: 430, background: T.bgCard, borderRadius: "20px 20px 0 0", padding: 24, boxSizing: "border-box", boxShadow: "0 -8px 32px rgba(0,0,0,0.4)" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                    <div>
                        <div style={{ fontSize: 16, fontWeight: 800, color: T.texto }}>Minha frase</div>
                        <div style={{ fontSize: 12, color: T.textoSecundario }}>Uma versículo, citação ou descrição</div>
                    </div>
                    <button onClick={onFechar} style={{ background: T.bgCardSecundario, border: "none", borderRadius: "50%", width: 32, height: 32, fontSize: 16, cursor: "pointer", color: T.texto }}>✕</button>
                </div>
                <textarea value={frase} onChange={e => setFrase(e.target.value)} placeholder='"Louve ao Senhor com toda a sua alma" — Sl 146' maxLength={120} rows={3}
                          style={{ width: "100%", padding: "12px 14px", borderRadius: 12, border: `1px solid ${T.borda}`, background: T.bgCardSecundario, color: T.texto, fontSize: 14, resize: "none", boxSizing: "border-box", outline: "none", fontFamily: "inherit" }} />
                <div style={{ fontSize: 11, color: T.textoSecundario, textAlign: "right", marginBottom: 12 }}>{frase.length}/120</div>
                <button onClick={salvar} disabled={salvando} style={{ width: "100%", padding: 13, borderRadius: 12, background: `linear-gradient(135deg, ${GOLD}, #FFD166)`, border: "none", color: BLUE, fontWeight: 800, fontSize: 14, cursor: "pointer", opacity: salvando ? 0.7 : 1 }}>
                    {salvando ? "Salvando..." : "✓ Salvar"}
                </button>
            </div>
        </div>,
        document.body
    );
}

// ── Modal editar post ──────────────────────────────────────────
function ModalEditarPost({ post, onSalvar, onFechar, tema: T }) {
    const [texto, setTexto] = useState(post?.texto || "");
    const [salvando, setSalvando] = useState(false);

    const salvar = async () => {
        if (!texto.trim()) return;
        setSalvando(true);
        try {
            await fetch(`${API}/api/grupos/mural/${post.id}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
                body: JSON.stringify({ texto }),
            });
            onSalvar(post.id, texto);
        } catch {
            onSalvar(post.id, texto); // fallback local
        } finally {
            setSalvando(false);
        }
    };

    return createPortal(
        <div onClick={onFechar} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 99999, display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
            <div onClick={e => e.stopPropagation()} style={{ width: "100%", maxWidth: 430, background: T.bgCard, borderRadius: "20px 20px 0 0", padding: 24, boxSizing: "border-box", boxShadow: "0 -8px 32px rgba(0,0,0,0.4)" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                    <div style={{ fontSize: 16, fontWeight: 800, color: T.texto }}>Editar post</div>
                    <button onClick={onFechar} style={{ background: T.bgCardSecundario, border: "none", borderRadius: "50%", width: 32, height: 32, fontSize: 16, cursor: "pointer", color: T.texto }}>✕</button>
                </div>
                <textarea value={texto} onChange={e => setTexto(e.target.value)} rows={4}
                          style={{ width: "100%", padding: "12px 14px", borderRadius: 12, border: `1px solid ${T.borda}`, background: T.bgCardSecundario, color: T.texto, fontSize: 14, resize: "none", boxSizing: "border-box", outline: "none", fontFamily: "inherit" }} />
                <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
                    <button onClick={onFechar} style={{ flex: 1, padding: 12, borderRadius: 12, background: T.bgCardSecundario, border: "none", color: T.texto, fontWeight: 600, cursor: "pointer" }}>Cancelar</button>
                    <button onClick={salvar} disabled={salvando || !texto.trim()} style={{ flex: 2, padding: 12, borderRadius: 12, background: `linear-gradient(135deg, ${GOLD}, #FFD166)`, border: "none", color: BLUE, fontWeight: 800, fontSize: 14, cursor: "pointer", opacity: salvando ? 0.7 : 1 }}>
                        {salvando ? "Salvando..." : "✓ Salvar"}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}

// ── Post do mural ──────────────────────────────────────────────
function PostMural({ post, usuarioId, isLider, onReagir, onEditar, tema: T }) {
    const [mostrarEmojis, setMostrarEmojis] = useState(false);
    const temReacoes = post.reacoes && Object.keys(post.reacoes).length > 0;
    // usuario_reacoes: array de emojis que o usuário já reagiu
    const minhasReacoes = post.usuario_reacoes || [];
    const podeEditar = post.user_id === usuarioId || isLider;

    return (
        <div style={{ background: T.bgCard, borderRadius: 18, padding: "14px 16px", marginBottom: 12, border: `1px solid ${T.borda}` }}>
            {/* Cabeçalho */}
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
                <Avatar foto={post.autor_foto} nome={post.autor_nome} size={38} />
                <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, fontWeight: 700, color: T.texto }}>{post.autor_nome}</div>
                    <div style={{ fontSize: 11, color: T.textoSecundario }}>{tempoRelativo(post.created_at)}</div>
                </div>
                {/* Botão editar — só para autor ou líder */}
                {podeEditar && (
                    <button onClick={() => onEditar(post)} style={{ background: "none", border: `1px solid ${T.borda}`, borderRadius: 8, padding: "4px 10px", color: T.textoSecundario, fontSize: 11, cursor: "pointer" }}>
                        ✏️
                    </button>
                )}
            </div>

            {/* Texto */}
            {post.texto && (
                <div style={{ fontSize: 14, color: T.texto, lineHeight: 1.6, marginBottom: 8, whiteSpace: "pre-wrap" }}>
                    {post.texto}
                </div>
            )}

            {/* Imagem */}
            {post.imagem && (
                <img src={post.imagem} alt="post" style={{ width: "100%", borderRadius: 12, marginBottom: 8, display: "block" }} />
            )}

            {/* Reações existentes com highlight das minhas */}
            {temReacoes && (
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 8 }}>
                    {Object.entries(post.reacoes).map(([emoji, total]) => {
                        const jáReagi = minhasReacoes.includes(emoji);
                        return (
                            <button key={emoji} onClick={() => onReagir(post.id, emoji)} style={{
                                background: jáReagi ? `${GOLD}22` : T.bgCardSecundario,
                                border: `1px solid ${jáReagi ? GOLD : T.borda}`,
                                borderRadius: 20, padding: "3px 10px", fontSize: 13,
                                cursor: "pointer", color: jáReagi ? GOLD : T.texto,
                                display: "flex", alignItems: "center", gap: 4,
                                fontWeight: jáReagi ? 700 : 400,
                                transition: "all 0.15s",
                            }}>
                                {emoji} <span style={{ fontSize: 11 }}>{total}</span>
                            </button>
                        );
                    })}
                </div>
            )}

            {/* Botão reagir */}
            <div style={{ position: "relative" }}>
                <button onClick={() => setMostrarEmojis(p => !p)} style={{ background: "none", border: "none", color: T.textoSecundario, fontSize: 12, cursor: "pointer", padding: "2px 0", display: "flex", alignItems: "center", gap: 4 }}>
                    <span style={{ fontSize: 15 }}>😊</span> Reagir
                </button>
                {mostrarEmojis && (
                    <div style={{ position: "absolute", bottom: "100%", left: 0, background: T.bgCard, border: `1px solid ${T.borda}`, borderRadius: 24, padding: "8px 12px", display: "flex", gap: 8, zIndex: 10, boxShadow: "0 4px 20px rgba(0,0,0,0.2)", marginBottom: 6 }}>
                        {EMOJIS_REACAO.map(e => (
                            <button key={e} onClick={() => { onReagir(post.id, e); setMostrarEmojis(false); }}
                                    style={{ background: "none", border: "none", fontSize: 22, cursor: "pointer", padding: "2px 3px", borderRadius: 8, opacity: minhasReacoes.includes(e) ? 0.5 : 1 }}
                                    onMouseOver={ev => ev.currentTarget.style.transform = "scale(1.3)"}
                                    onMouseOut={ev => ev.currentTarget.style.transform = "scale(1)"}
                            >{e}</button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

// ── Novo post ──────────────────────────────────────────────────
function NovoPost({ onPublicar, carregando, tema: T }) {
    const [texto, setTexto] = useState("");
    const fileRef = useRef(null);
    const [imagem, setImagem] = useState(null);

    const selecionarImagem = e => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = ev => setImagem(ev.target.result);
        reader.readAsDataURL(file);
        e.target.value = "";
    };

    const publicar = () => {
        if (!texto.trim() && !imagem) return;
        onPublicar({ texto: texto.trim(), imagem });
        setTexto(""); setImagem(null);
    };

    return (
        <div style={{ background: T.bgCard, borderRadius: 18, padding: "14px 16px", marginBottom: 16, border: `1px solid ${GOLD}33` }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: GOLD, marginBottom: 10, textTransform: "uppercase", letterSpacing: 0.8 }}>
                📢 Novo aviso para a equipe
            </div>
            <textarea value={texto} onChange={e => setTexto(e.target.value)} placeholder="Escreva um aviso, recado ou versículo para a equipe..." rows={3}
                      style={{ width: "100%", padding: "10px 12px", borderRadius: 12, border: `1px solid ${T.borda}`, background: T.bgCardSecundario, color: T.texto, fontSize: 14, resize: "none", boxSizing: "border-box", outline: "none", fontFamily: "inherit" }} />
            {imagem && (
                <div style={{ position: "relative", marginTop: 8, marginBottom: 4 }}>
                    <img src={imagem} alt="preview" style={{ width: "100%", borderRadius: 10, display: "block" }} />
                    <button onClick={() => setImagem(null)} style={{ position: "absolute", top: 6, right: 6, background: "rgba(0,0,0,0.6)", border: "none", borderRadius: "50%", width: 28, height: 28, color: "white", cursor: "pointer", fontSize: 14 }}>✕</button>
                </div>
            )}
            <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
                <input ref={fileRef} type="file" accept="image/*" style={{ display: "none" }} onChange={selecionarImagem} />
                <button onClick={() => fileRef.current?.click()} style={{ padding: "8px 14px", borderRadius: 10, border: `1px solid ${T.borda}`, background: T.bgCardSecundario, color: T.textoSecundario, fontSize: 13, cursor: "pointer" }}>📷 Foto</button>
                <button onClick={publicar} disabled={(!texto.trim() && !imagem) || carregando}
                        style={{ flex: 1, padding: "8px 0", borderRadius: 10, background: (texto.trim() || imagem) ? `linear-gradient(135deg, ${GOLD}, #FFD166)` : T.bgCardSecundario, border: "none", color: (texto.trim() || imagem) ? BLUE : T.textoSecundario, fontWeight: 800, fontSize: 13, cursor: (texto.trim() || imagem) ? "pointer" : "default", transition: "all 0.15s" }}>
                    {carregando ? "Publicando..." : "Publicar"}
                </button>
            </div>
        </div>
    );
}

// ── Componente principal ───────────────────────────────────────
export default function RedeSocial({ tema, perfil, membros: membrosProps = [], adminMode }) {
    const T = TEMAS[tema] || tema;
    const [aba, setAba] = useState("equipe");
    const isLider = perfil?.role === "lider" || adminMode;
    const podePostarMural = isLider || !!perfil?.can_post_mural || !!perfil?.permissoes?.can_post_mural;
    const [membros, setMembros] = useState(membrosProps);
    const [posts, setPosts] = useState([]);
    const [carregandoPosts, setCarregandoPosts] = useState(true);
    const [publicando, setPublicando] = useState(false);
    const [editandoMembro, setEditandoMembro] = useState(null);
    const [editandoPost, setEditandoPost] = useState(null);

    useEffect(() => { if (membrosProps.length > 0) setMembros(membrosProps); }, [membrosProps]);

    useEffect(() => {
        if (aba !== "mural") return;
        setCarregandoPosts(true);
        fetch(`${API}/api/grupos/mural`, { headers: { Authorization: `Bearer ${getToken()}` } })
            .then(r => r.json())
            .then(data => { setPosts(data.posts || []); setCarregandoPosts(false); })
            .catch(() => setCarregandoPosts(false));
    }, [aba]);

    const publicarPost = async ({ texto, imagem }) => {
        setPublicando(true);
        try {
            const res = await fetch(`${API}/api/grupos/mural`, {
                method: "POST",
                headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
                body: JSON.stringify({ texto, imagem }),
            });
            const data = await res.json();
            if (data.post) setPosts(prev => [{ ...data.post, usuario_reacoes: [] }, ...prev]);
        } catch {
            setPosts(prev => [{
                id: Date.now(), texto, imagem,
                autor_nome: perfil?.nome || "Líder",
                autor_foto: perfil?.foto || null,
                created_at: new Date().toISOString(),
                reacoes: {}, usuario_reacoes: [],
                user_id: perfil?.id,
            }, ...prev]);
        } finally {
            setPublicando(false);
        }
    };

    const reagir = async (postId, emoji) => {
        // Toggle local imediato
        setPosts(prev => prev.map(p => {
            if (p.id !== postId) return p;
            const reacoes = { ...(p.reacoes || {}) };
            const minhas = [...(p.usuario_reacoes || [])];
            const jaReagi = minhas.includes(emoji);
            if (jaReagi) {
                // remover
                reacoes[emoji] = Math.max((reacoes[emoji] || 1) - 1, 0);
                if (reacoes[emoji] === 0) delete reacoes[emoji];
                return { ...p, reacoes, usuario_reacoes: minhas.filter(e => e !== emoji) };
            } else {
                // adicionar
                reacoes[emoji] = (reacoes[emoji] || 0) + 1;
                return { ...p, reacoes, usuario_reacoes: [...minhas, emoji] };
            }
        }));

        // Salvar no backend
        try {
            const res = await fetch(`${API}/api/grupos/mural/${postId}/reagir`, {
                method: "POST",
                headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
                body: JSON.stringify({ emoji }),
            });
            const data = await res.json();
            // Atualiza com dados reais do servidor
            if (data.reacoes) {
                setPosts(prev => prev.map(p => p.id !== postId ? p : { ...p, reacoes: data.reacoes }));
            }
        } catch {}
    };

    const salvarFrase = (membroId, frase) => {
        setMembros(prev => prev.map(m => m.id === membroId ? { ...m, frase } : m));
        setEditandoMembro(null);
    };

    const salvarPost = (postId, novoTexto) => {
        setPosts(prev => prev.map(p => p.id === postId ? { ...p, texto: novoTexto } : p));
        setEditandoPost(null);
    };

    const membrosOrdenados = [...membros].sort((a, b) => {
        if (a.role === "lider") return -1;
        if (b.role === "lider") return 1;
        return (a.nome || "").localeCompare(b.nome || "");
    });

    return (
        <div style={{ paddingBottom: 80 }}>
            <style>{`@keyframes fadeIn { from { opacity:0; transform:translateY(6px) } to { opacity:1; transform:translateY(0) } } @keyframes spin { to { transform: rotate(360deg) } }`}</style>

            {/* Header */}
            <div style={{ background: T.nav, borderBottom: `1px solid ${T.borda}`, padding: "14px 16px 0" }}>
                <div style={{ marginBottom: 14 }}>
                    <div style={{ fontSize: 20, fontWeight: 900, color: T.texto }}>👥 Equipe</div>
                    <div style={{ fontSize: 12, color: T.textoSecundario, marginTop: 2 }}>
                        {membros.length} membro{membros.length !== 1 ? "s" : ""} no ministério
                    </div>
                </div>
                <div style={{ display: "flex" }}>
                    {[["equipe", "👥 Membros"], ["mural", "📢 Mural"]].map(([id, label]) => (
                        <button key={id} onClick={() => setAba(id)} style={{
                            flex: 1, padding: "10px 0", border: "none", background: "transparent",
                            color: aba === id ? GOLD : T.textoSecundario,
                            fontWeight: aba === id ? 800 : 500, fontSize: 14, cursor: "pointer",
                            borderBottom: `2px solid ${aba === id ? GOLD : "transparent"}`,
                            transition: "all 0.15s",
                        }}>{label}</button>
                    ))}
                </div>
            </div>

            {/* Aba Membros */}
            {aba === "equipe" && (
                <div style={{ padding: "16px 16px 0", animation: "fadeIn 0.2s ease" }}>
                    {membrosOrdenados.length === 0 ? (
                        <div style={{ textAlign: "center", padding: "48px 24px", color: T.textoSecundario }}>
                            <div style={{ fontSize: 48, marginBottom: 12 }}>👥</div>
                            <div style={{ fontSize: 15, fontWeight: 700, color: T.texto, marginBottom: 4 }}>Nenhum membro ainda</div>
                            <div style={{ fontSize: 13 }}>Compartilhe o código do grupo para convidar a equipe.</div>
                        </div>
                    ) : (
                        membrosOrdenados.map(m => (
                            <CardMembro key={m.id} membro={m} souEu={m.id === perfil?.id} adminMode={adminMode} onEditar={setEditandoMembro} tema={T} />
                        ))
                    )}
                </div>
            )}

            {/* Aba Mural */}
            {aba === "mural" && (
                <div style={{ padding: "16px 16px 0", animation: "fadeIn 0.2s ease" }}>
                    {/* Caixa de novo post — só para quem tem permissão */}
                    {podePostarMural && (
                        <NovoPost onPublicar={publicarPost} carregando={publicando} tema={T} />
                    )}
                    {/* Mensagem para quem não pode postar */}
                    {!podePostarMural && (
                        <div style={{ background: T.bgCard, borderRadius: 14, padding: "12px 16px", marginBottom: 16, border: `1px solid ${T.borda}`, fontSize: 13, color: T.textoSecundario, textAlign: "center" }}>
                            🔒 Apenas líderes e membros autorizados podem publicar
                        </div>
                    )}

                    {carregandoPosts ? (
                        <div style={{ textAlign: "center", padding: "40px 0", color: T.textoSecundario }}>
                            <div style={{ width: 32, height: 32, border: `3px solid ${T.borda}`, borderTop: `3px solid ${GOLD}`, borderRadius: "50%", animation: "spin 1s linear infinite", margin: "0 auto 12px" }} />
                            Carregando mural...
                        </div>
                    ) : posts.length === 0 ? (
                        <div style={{ textAlign: "center", padding: "48px 24px", color: T.textoSecundario }}>
                            <div style={{ fontSize: 48, marginBottom: 12 }}>📢</div>
                            <div style={{ fontSize: 15, fontWeight: 700, color: T.texto, marginBottom: 4 }}>Mural vazio</div>
                            <div style={{ fontSize: 13 }}>
                                {podePostarMural ? "Publique o primeiro aviso para a equipe acima." : "O líder ainda não publicou avisos."}
                            </div>
                        </div>
                    ) : (
                        posts.map(post => (
                            <PostMural
                                key={post.id}
                                post={post}
                                usuarioId={perfil?.id}
                                isLider={isLider}
                                onReagir={reagir}
                                onEditar={setEditandoPost}
                                tema={T}
                            />
                        ))
                    )}
                </div>
            )}

            {/* Modal editar frase */}
            {editandoMembro && (
                <ModalEditarFrase membro={editandoMembro} onSalvar={salvarFrase} onFechar={() => setEditandoMembro(null)} tema={T} />
            )}

            {/* Modal editar post */}
            {editandoPost && (
                <ModalEditarPost post={editandoPost} onSalvar={salvarPost} onFechar={() => setEditandoPost(null)} tema={T} />
            )}
        </div>
    );
}